module.exports={"Star Rating":"Sterwaardering","# star(s)":"{currentRating, plural, =1{# ster} other{# sterren}}"};